import { useState } from "react";
import { useAuth } from "./context/authContext";
import { Link, useNavigate } from "react-router-dom";
import { Alert } from "./Alert";
import logo from "./logo.png"



export function Login() {
  const [user, setUser] = useState({
    email: "",
    password: "",
  });

  const { login, loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState();

  const handleChange = ({ target: { name, value } }) => {
    setUser({ ...user, [name]: value }); //...user es para extraer los datos de los campos en ese momento
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await login(user.email, user.password);
      navigate("/");
    } catch (error) {
      setError(error.message);
      console.log(error.code);
      if (error.code === "auth/weak-password") {
        setError("password debe ser mayor a 6 digitos");
      }
      if (error.code === "auth/email-already-in-use") {
        setError("correo ya esta registrado");
      }
    }
    //console.log(user)
  };

  //console.log(name, value)

  const handleGoogleSignin = async () => {
    try {
      //throw new Error("google error")
      await loginWithGoogle();
      console.log(loginWithGoogle);
      navigate("/");
    } catch (error) {
      setError(error.message);
    }
  };

  const [visible, setVisible] = useState(true);

  // Función para cerrar la barra de aviso
  const cerrarAviso = () => {
    setVisible(false);
  };



  return (
    
    <div className="w-full max-w-lg m-auto ">
           {visible && (
        <div style={{ backgroundColor: 'yellow', padding: '10px', position: 'fixed', top: 0, left: 0, width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: 9999 }}>
          <p style={{ margin: 0 }}> Por ahora está activo solo el ingreso con su cuenta de Google.</p>
          <button onClick={cerrarAviso}>Cerrar</button>
        </div>
      )}
      {error && <Alert message={error} />}
      <div className="flex justify-center">
      <img src={logo} alt="Imagen 1" className="w-1/3 rounded-full" />
      </div>

 
      
      <form
        onSubmit={handleSubmit}
        className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"
      >
        {/* 
        <div className="mb-4">
          <label htmlFor="email" className="block text-gray-700 text-sm font-fold mb-2">Email</label>
          <input
            type="email"
            name="email"
            placeholder="example@gmail.com"
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight-focus:outline-none focus:shadow-outline"
            onChange={handleChange}
          ></input>
        </div>

        <div className="mb-4">
          <label htmlFor="password" className="block text-gray-700 text-sm font-fold mb-2">Contraseña</label>
          <input
            type="password"
            name="password"
            placeholder="********"
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            onChange={handleChange}
          ></input>
        </div>

        <button className="bg-blue-500 hover:bg-blue-700 text-white text-sm font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline">Login</button>*/}
      </form>

     {/*  <p className="my-4 text-sm flex justify-between px-3">¿No tienes una cuenta? <Link to="/register">Registrate</Link></p>*/}

      <button className="bg-slate-50 hover:bg-slate-200 text-black shadow-md rounded border-2 border-gray-300 py-2 px-4 w-full" onClick={handleGoogleSignin}>Google Login</button>
    </div>
  );
}
